import { register as registerEmployment } from './domains/employment/register'
import {
  EmployerOrganisationSettingsGate,
  type TenantPluginRegister,
} from '@yeshuman/sdk'

export const register: TenantPluginRegister = (app) => {
  registerEmployment(app)
  app.routes.add({
    path: '/organisation/settings/*',
    element: EmployerOrganisationSettingsGate,
  })
}

export const providesDomains = ['employment']

export const requiresProduct = '>=2.12,<3'
